import request, { Method } from './request';

/**
 * Performs the `fetch` request but ensures that
 * CSRF token and proper `X-Requested-With` HTTP headers are
 * included as well. It also throws an error if `response.ok` is false.
 * The response is excepted to be JSON, and it will be automatically parsed
 * and returned. If you need to read response headers or handle the response
 * otherwise, use `request` instead.
 */
export default async function requestJson<ResponseData = any>(
  method: Method,
  url: string,
  payload?: unknown,
): Promise<ResponseData> {
  const response = await request(method, url, payload);
  return response.json();
}
